export default {
    methods: {
        getItemSingleBaseUrl() {
            return this.$store.getters.listConfig.ITEM_SINGLE_BASE_URL || "";
        },
    },
};
